const styles = (theme) => ({
  select: {
    minWidth: 'auto !important',
  },
});

export default styles;
